export default function Legend(props) {
  return (
    <table border="1" cellpadding="0" align="center" style={{width:"100%",fontSize:"0.68em",borderCollapse: "collapse",whiteSpace: "nowrap"}}>
      <tr>
        <th width="12%" align="center">凡例</th>
        <th width="22%" align="center">気温[℃]</th>
        <th width="22%" align="center">湿度[%]</th>
        <th width="22%" align="center" title="気象庁ホームページ" style={{cursor: "help", textDecoration:"underline"}} onClick={()=>window.open('https://www.jma.go.jp/jma/kishou/know/yougo_hp/kazehyo.html')}>風速[m/s]</th>
        <th width="22%" align="center" title="気象庁ホームページ" style={{cursor: "help", textDecoration:"underline"}} onClick={()=>window.open('https://www.jma.go.jp/jma/kishou/know/yougo_hp/amehyo.html')}>雨量[㎜/h]</th>
      </tr>
      <tr><td bgcolor="#ACB9C"></td><td align="center">～25</td><td align="center">～40</td><td align="center">～10</td><td align="center">～10</td></tr> 
      <tr><td bgcolor="#B4C6E7"></td><td align="center">25</td><td align="center">40</td><td align="center">10</td><td align="center">10</td></tr> 
      <tr><td bgcolor="#8EA9DB"></td><td align="center">30</td><td align="center">50</td><td align="center">15</td><td align="center">20</td></tr> 
      <tr><td bgcolor="#4472C4"></td><td align="center">35</td><td align="center">60</td><td align="center">20</td><td align="center">30</td></tr> 
      <tr><td bgcolor="#203764"></td><td align="center">40</td><td align="center">70</td><td align="center">30</td><td align="center">50</td></tr> 
    </table>
  );
}
